var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M10.75 7.125a.4.4 0 0 0-.375-.375h-5.75a.38.38 0 0 0-.375.375v.75c0 .219.156.375.375.375h5.75a.38.38 0 0 0 .375-.375zm6.125 9.063c.156-.125.156-.375 0-.532l-3.781-3.781c-.094-.062-.188-.125-.281-.125h-.407A6.54 6.54 0 0 0 14 7.5C14 3.938 11.063 1 7.5 1 3.906 1 1 3.938 1 7.5 1 11.094 3.906 14 7.5 14a6.58 6.58 0 0 0 4.25-1.562v.406q0 .14.094.281l3.781 3.781c.156.157.406.157.531 0zM12.5 7.5c0 2.781-2.25 5-5 5-2.781 0-5-2.219-5-5 0-2.75 2.219-5 5-5 2.75 0 5 2.25 5 5"
  })));
};
export default SvgZoomOut;